import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      overflow: 'auto',
      margin: theme.spacing(1),
    },
    dateInput: {
      '& .MuiInputLabel-root': {
        // backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0, 0.5),
        zIndex: 1,
        backgroundColor: Colors.primaryBg,
        // padding: theme.spacing(0.75),
        // height: 30,
        color: Colors.textBlack,
      },
      '& .MuiOutlinedInput-root': {
        alignItems: 'center',
      },
    },
    submitButton: {
      '&:hover': {
        backgroundColor: Colors.darkBluish,
      },
    },
  }),
);
